import { render, staticRenderFns } from "./PageFinished.vue?vue&type=template&id=4a1ea8a8"
import script from "./PageFinished.vue?vue&type=script&lang=js"
export * from "./PageFinished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports